import { Panel } from '../core/Panel';
import { Sim, SeedType, SEED_TYPES, SEED_COSTS } from '../../game/simulation';
import { ICON } from '../icons';

export class SeedsPanel extends Panel {
  constructor(sim: Sim) { super(sim); }
  id() { return 'seeds'; }
  title() { return 'Seeds'; }
  hashInputs() {
    const s = this.sim.state;
    return JSON.stringify({ sel: s.selectedSeed, seeds: s.res.seeds, lv: s.prog.level });
  }
  body() {
    const s = this.sim.state;
    const lv = s.prog.level;
    const seedGlyph: Record<SeedType, string> = { wheat: ICON.wheat, corn: ICON.corn, carrot: ICON.carrot };
    const cards = SEED_TYPES.map(seed => {
      const locked = seed !== 'wheat' && lv < 2;
      const owned = s.res.seeds[seed] ?? 0;
      const active = s.selectedSeed === seed && !locked;
      return `
        <div class="ui-card ${active ? 'active' : ''} ${locked ? 'locked' : ''}" data-seed="${seed}">
          <span class="ui-card__icon glyph">${seedGlyph[seed]}</span>
          <div>
            <div class="ui-card__title">${seed}${locked ? ' (LV2)' : ''}</div>
            <div class="ui-card__sub">In stock: ${owned}</div>
          </div>
          <span class="ui-card__cost">${SEED_COSTS[seed]}<span class="glyph glyph-inline">${ICON.coin}</span></span>
        </div>`;
    }).join('');
    return `
      ${cards}
      <div class="ui-tip">Buy seeds at the mailbox — they're consumed when you plant.</div>
      <button class="ui-btn ui-btn--primary ui-btn--block" data-act="select-plant">Switch to Plant tool</button>
      <button class="ui-btn ui-btn--block" data-act="reposition">↔ Reposition seed bag</button>
    `;
  }
  onClick(e: Event) {
    const t = e.target as HTMLElement;
    const seedEl = t.closest('[data-seed]') as HTMLElement | null;
    if (seedEl) {
      if (seedEl.classList.contains('locked')) {
        this.sim.bus.emit({ type: 'blocked', reason: 'Unlocks at level 2' });
        return;
      }
      this.sim.setSelectedSeed(seedEl.dataset.seed as SeedType);
      return;
    }
    const actEl = t.closest('[data-act]') as HTMLElement | null;
    if (actEl?.dataset.act === 'select-plant') this.sim.setTool('plant');
    else if (actEl?.dataset.act === 'reposition') {
      this.sim.startMoving('seedbag');
      this.hide();
    }
  }
}
